import styles from '@styles/styles';

// On web, we can use flex to fit the content to fit the viewport within a ScrollView.
const scrollViewContentContainerStyles = styles.flex1;

export default scrollViewContentContainerStyles;
